import { Component, Story, Knobs, Accents } from './DocTypes';

const PlaygroundKnobs: Knobs = {
  value: {
    default: '75',
    editor: 'number',
  },
  accent: {
    default: '',
    editor: 'dropdown',
    editorOptions: [''].concat(Accents),
  },
  text: {
    default: '',
    editor: 'textbox',
  },
  inline: {
    default: false,
    editor: 'checkbox',
  },
  width: {
    default: '',
    editor: 'textbox',
  },
  height: {
    default: '',
    editor: 'textbox',
  },
};

const PlaygroundStory: Story = {
  title: 'Playground',
  description: 'An tag-bar where you can change all the attributes',
  coreComponent: {
    html: `<tag-bar{{...knobs}}>
</tag-bar>`,
    knobs: PlaygroundKnobs,
  },
  reactWrapper: { jsx: `<TagBar{{...knobs}} />`, knobs: PlaygroundKnobs },
};

export const TagBarDocs: Component = {
  type: 'component',
  name: 'bar',
  description: 'Renders a horizontal bar that is X% filled in',
  mobileFriendly: true,
  popular: false,
  preRelease: '',
  props: [
    {
      name: 'value',
      description: 'The percentage value',
      type: 'number',
    },
    {
      name: 'text',
      description: 'The text to display next to the bar',
      type: 'text',
    },
    {
      name: 'width',
      description: 'The width of the bar',
      type: 'text',
    },
    {
      name: 'height',
      description: 'The height of the bar',
      type: 'text',
    },
    {
      name: 'accent',
      description: 'The colour of the badge',
      type: 'string',
      default: 'dolphinblue',
    },
    {
      name: 'inline',
      description: 'Whether the text is display to the right of the bar or under it',
      type: 'boolean',
      default: 'false',
    },
  ],
  reactPropOverrides: [],
  events: [],
  methods: [],
  stories: [PlaygroundStory],
};
